<template>
  <div class="m-3" v-if="customerSchedule && customerSchedule.dateTo">
    <custom-button
      size="small"
      :gradient="true"
      :title="'Przypisz opiekę'"
      :radius="true"
      :customStyles="'width: 212px; height: 37px'"
      @click="
        (isAssigningVisible = !isAssigningVisible), (selectedOrder = null)
      "
    />

    <div
      class="assigning-box"
      v-if="isAssigningVisible && employeesOptions && employeesOptions[0]"
      :key="customKey"
    >
      <p v-if="selectedOrder" class="days-label ml-2 mt-4">
        Edycja zlecenia pomiędzy podopiecznym, a opiekunem
        {{ selectedOrder.employee.firstName }}
        {{ selectedOrder.employee.lastName }}
      </p>

      <div
        v-for="(employee, index) in employeesAssigned"
        :key="index"
        class="p-0"
      >
        <div class="select-employee">
          <custom-select
            v-if="!selectedOrder"
            class="mt-2"
            :options="employeesOptions"
            :graySelect="true"
            :isAutocomplete="true"
            title="Wybierz opiekunkę"
            @newPick="(e) => handlePickEmployee(e, index)"
            :prePick="employee.employeeId"
            :customStyles="'width: 300px'"
            :large="true"
            :additionalLabel="panelCan('showMainAppLinking') ? $mainAppBadge : ''"
          />

          <dod-custom-date-input
            :minDate="getMinDateForNewSchedule()"
            :placeholder="employee.dateFrom || 'Od'"
            :isRequired="true"
            @dateChange="(e) => handleChangeDate(e, index, 'dateFrom')"
          />

          <dod-custom-date-input
            :placeholder="employee.dateTo || 'Do'"
            @dateChange="(e) => handleChangeDate(e, index, 'dateTo')"
          />
        </div>

        <div class="ml-2">
          <div class="p-0 flex">
            <p class="days-label">Dni i godziny pracy opiekunki</p>
            <span
              v-if="index"
              class="delete-char"
              @click="handleDeleteEmployee(employee.employeeId)"
              >X</span
            >
          </div>
          <p v-if="customOrder && customerSchedule">
            pon. {{ scheduledDaysCounter.MONDAY }}, wt.
            {{ scheduledDaysCounter.TUESDAY }}, śr.
            {{ scheduledDaysCounter.WEDNESDAY }}, czw.
            {{ scheduledDaysCounter.THURSDAY }}, pt.
            {{ scheduledDaysCounter.FRIDAY }}, sob.
            {{ scheduledDaysCounter.SATURDAY }}, nd.
            {{ scheduledDaysCounter.SUNDAY }},
          </p>
          <div v-if="!customOrder" class="days">
            <div
              :class="index === 5 || index === 6 ? 'day-color' : ''"
              class="day"
              v-for="(day, index) in Object.keys(employee.days)"
              :key="day"
            >
              <p>{{ day }}</p>
              <template v-if="employee.notIncludedDays">
                <input
                  v-if="!employee.notIncludedDays.includes(day)"
                  v-model="employee.days[day].status"
                  type="checkbox"
                />
                <p v-else>-</p>
              </template>
              <template v-else>
                <input
                  v-if="!notIncludedDays.includes(day)"
                  v-model="employee.days[day].status"
                  type="checkbox"
                />
                <p v-else>-</p>
              </template>
            </div>
            <div :class="'day-color'" class="day">
              <p>Św.</p>
              <template>
                <input
                  v-model="employee.holidays.status"
                  type="checkbox"
                  :disabled="!customerSchedule.holidaysNumberOfHours"
                />
              </template>
            </div>
          </div>
          <div v-else class="days">
            <div
              :class="index === 5 || index === 6 ? 'day-color' : ''"
              class="day"
              v-for="(day, index) in Object.keys(employee.days)"
              :key="day"
            >
              <p>{{ day }}</p>
              <input
                v-model.number="employee.days[day].numberOfHours"
                type="number"
                max="24"
                min="0"
                step="1"
              />
            </div>
            <div :class="'day-color'" class="day">
              <p>Św.</p>
              <input
                v-model.number="employee.holidays.numberOfHours"
                type="number"
                max="24"
                min="0"
                step="1"
              />
            </div>
          </div>
        </div>
        <div
          class="already-added-employee-error"
          v-if="alreadyAddedEmployeeError"
        >
          Podopieczny ma już zaplanowane wizyty w tym okresie. Czy chcesz
          zmienić opiekunkę od wybranej daty?
        </div>
      </div>
      <!-- <div class="custom-order-input" v-if="!selectedOrder"> -->
      <div class="custom-order-input">
        <input id="customOrderInput" type="checkbox" v-model="customOrder" />
        <label for="customOrderInput">Zlecenie niestandardowe</label>
      </div>
      <div
        v-if="
          customOrder &&
          employeesAssigned.length !== employeesOptions.length &&
          !selectedOrder
        "
        class="custom-order-input"
        @click="addAnotherEmployee"
      >
        <p class="add-employee">Dodaj kolejnego opiekuna</p>
      </div>
      <textarea
        v-model="orderNote"
        placeholder="Dodatkowe informacje"
        class="order-note"
        maxlength="1000"
      >
      </textarea>
      <div class="assign-button">
        <custom-button
          :title="'ZAPISZ'"
          @click="assignEmployeeToCustomer"
          :customStyles="'width: 300px; height: 50px;'"
          :disabled="loading"
          v-if="!selectedOrder"
        />

        <custom-button
          :title="'ZAPISZ ZMIANY W ZLECENIU'"
          @click="assignEmployeeToCustomer"
          :customStyles="'width: 300px; height: 50px;'"
          :disabled="loading"
          v-if="selectedOrder"
        />
      </div>
    </div>

    <custom-modal
      :title="'Czy dodać zlecenie?'"
      :id="'max-hours-modal'"
      :modalKey="modalKey"
      :key="modalKey"
      v-if="employeesAssigned && employeesAssigned.length > 0"
    >
      <template #content>
        <div
          v-for="employee in employeesAssigned"
          :key="employee.employeeId + modalKey"
        >
          <p>
            <b
              >Opiekun przekroczy maksymalną ilość godzin na DNR (110h) w
              miesiącach:
              {{
                employee.mothsWithMaxHours
                  ? employee.mothsWithMaxHours
                      .map((m) => formatMonthNumberToMonthName(m))
                      .join(", ")
                  : []
              }}</b
            >
          </p>
        </div>

        <div>Czy na pewno chcesz dodać zlecenie?</div>
        <div class="modal-buttons">
          <custom-button
            @click="closeMaxHoursModal()"
            :size="'small'"
            :title="'NIE'"
            :gray="true"
            :customStyles="'width: 50%'"
          />
          <custom-button
            @click="confirmMaxHoursModal()"
            :size="'small'"
            :title="'TAK'"
            :gradient="true"
            :customStyles="'width: 50%'"
          />
        </div>
      </template>
    </custom-modal>
    <button
      style="visibility: hidden"
      id="max-hours-modal-open"
      type="button"
      data-toggle="modal"
      data-target="#max-hours-modal"
    />
  </div>
</template>

<script>
import CustomButton from "../CustomButton.vue";
import CustomSelect from "../CustomSelect.vue";
import moment from "moment";
import DodCustomDateInput from "./DodCustomDateInput.vue";
import shared from "../../shared";
import CustomModal from "../CustomModal.vue";
export default {
  name: "AssigningEmployeeToCustomer",
  props: ["customerId", "orderToEdit"],
  components: {
    CustomButton,
    CustomSelect,
    DodCustomDateInput,
    CustomModal,
  },

  data() {
    return {
      selectedOrder: null,
      customOrder: false,
      isAssigningVisible: false,
      customKey: new Date().getTime(),
      employeesAssigned: [
        {
          employeeId: "",
          customerId: this.customerId,
          dateFrom: "",
          dateTo: "",
          days: {
            Pon: { status: false, numberOfHours: null },
            Wt: { status: false, numberOfHours: null },
            Śr: { status: false, numberOfHours: null },
            Czw: { status: false, numberOfHours: null },
            Pt: { status: false, numberOfHours: null },
            Sob: { status: false, numberOfHours: null },
            Nd: { status: false, numberOfHours: null },
          },
          daysBeforeEdit: {
            Pon: { status: false, numberOfHours: 0 },
            Wt: { status: false, numberOfHours: 0 },
            Śr: { status: false, numberOfHours: 0 },
            Czw: { status: false, numberOfHours: 0 },
            Pt: { status: false, numberOfHours: 0 },
            Sob: { status: false, numberOfHours: 0 },
            Nd: { status: false, numberOfHours: 0 },
          },
          holidays: { status: false, numberOfHours: null },
          holidaysBeforeEdit: { status: false, numberOfHours: 0 },

          notIncludedDays: null,
          mothsWithMaxHours: [],
        },
      ],
      loading: false,
      alreadyAddedEmployeeError: false,
      orderNote: "",
      modalKey: 0,
    };
  },

  watch: {
    orderToEdit() {
      this.isAssigningVisible = true;
      this.selectedOrder = this.orderToEdit;
      const days = this.orderToEdit.days;
      const mondayHours = days.find(
        (d) => d.dayName === "MONDAY"
      )?.numberOfHours;
      const tuesdayHours = days.find(
        (d) => d.dayName === "TUESDAY"
      )?.numberOfHours;
      const wednesdayHours = days.find(
        (d) => d.dayName === "WEDNESDAY"
      )?.numberOfHours;
      const thursdayHours = days.find(
        (d) => d.dayName === "THURSDAY"
      )?.numberOfHours;
      const fridayHours = days.find(
        (d) => d.dayName === "FRIDAY"
      )?.numberOfHours;
      const saturdayHours = days.find(
        (d) => d.dayName === "SATURDAY"
      )?.numberOfHours;
      const sundayHours = days.find(
        (d) => d.dayName === "SUNDAY"
      )?.numberOfHours;

      this.employeesAssigned = [
        {
          employeeId: this.selectedOrder.employee.id,
          customerId: this.selectedOrder.customer.id,
          dateFrom: moment(this.selectedOrder.dateFrom).format("YYYY-MM-DD"),
          dateTo: moment(this.selectedOrder.dateTo).format("YYYY-MM-DD"),
          days: {
            Pon: {
              status: this.scheduledDaysCounter.MONDAY ? true : false,
              numberOfHours: mondayHours || 0,
            },
            Wt: {
              status: this.scheduledDaysCounter.TUESDAY ? true : false,
              numberOfHours: tuesdayHours || 0,
            },
            Śr: {
              status: this.scheduledDaysCounter.WEDNESDAY ? true : false,
              numberOfHours: wednesdayHours || 0,
            },
            Czw: {
              status: this.scheduledDaysCounter.THURSDAY ? true : false,
              numberOfHours: thursdayHours || 0,
            },
            Pt: {
              status: this.scheduledDaysCounter.FRIDAY ? true : false,
              numberOfHours: fridayHours || 0,
            },
            Sob: {
              status: this.scheduledDaysCounter.SATURDAY ? true : false,
              numberOfHours: saturdayHours || 0,
            },
            Nd: {
              status: this.scheduledDaysCounter.SUNDAY ? true : false,
              numberOfHours: sundayHours || 0,
            },
          },
          daysBeforeEdit: {
            Pon: {
              status: this.scheduledDaysCounter.MONDAY ? true : false,
              numberOfHours: mondayHours || 0,
            },
            Wt: {
              status: this.scheduledDaysCounter.TUESDAY ? true : false,
              numberOfHours: tuesdayHours || 0,
            },
            Śr: {
              status: this.scheduledDaysCounter.WEDNESDAY ? true : false,
              numberOfHours: wednesdayHours || 0,
            },
            Czw: {
              status: this.scheduledDaysCounter.THURSDAY ? true : false,
              numberOfHours: thursdayHours || 0,
            },
            Pt: {
              status: this.scheduledDaysCounter.FRIDAY ? true : false,
              numberOfHours: fridayHours || 0,
            },
            Sob: {
              status: this.scheduledDaysCounter.SATURDAY ? true : false,
              numberOfHours: saturdayHours || 0,
            },
            Nd: {
              status: this.scheduledDaysCounter.SUNDAY ? true : false,
              numberOfHours: sundayHours || 0,
            },
          },
          holidays: {
            status: false,
            numberOfHours: 0,
          },
        },
      ];

      //this.customOrder = true;
    },
    employeesOptions() {
      if (!this.employeesAssigned[0].employeeId) {
        this.employeesAssigned[0].employeeId = this.employeesOptions[0]?.value;
        this.customKey = new Date().getTime();
      }
    },
    customOrder() {
      if (!this.customOrder) {
        this.employeesAssigned = [this.employeesAssigned[0]];
        this.employeesAssigned.forEach((e) =>
          Object.keys(e.days).forEach((day) => {
            e.days[day].numberOfHours = null;
          })
        );
      }
    },
  },
  methods: {
    formatMonthNumberToMonthName(monthStringNumber) {
      return shared.getPolishMonthNameByStringMonthNumber(monthStringNumber);
    },
    closeMaxHoursModal() {
      document.getElementById("max-hours-modal-close").click();
      this.employeesAssigned.forEach((e) => (e.mothsWithMaxHours = []));
    },
    openMaxHoursModal() {
      const button = document.getElementById("max-hours-modal-open");
      if (button) {
        button.click();
      }
    },
    async getCustomerScheduleDaysWhenDatesAreFilled(
      employeesAssignedToSearchDates
    ) {
      if (
        employeesAssignedToSearchDates.dateFrom &&
        employeesAssignedToSearchDates.dateTo
      ) {
        const days = await this.$store.dispatch(
          "getCustomerScheduleDaysBetweenDates",
          {
            customerId: this.customerId,
            dateFrom: moment(employeesAssignedToSearchDates.dateFrom).format(
              "YYYY-MM-DD"
            ),
            dateTo: moment(employeesAssignedToSearchDates.dateTo).format(
              "YYYY-MM-DD"
            ),
          }
        );

        const includedWeekdaysInCustomerSchedule =
          this.getWeekdayNamesFromGivenDates(days.map((d) => d.date));
        let notIncludedDays = [];
        if (!includedWeekdaysInCustomerSchedule.includes("Monday")) {
          notIncludedDays.push("Pon");
        }
        if (!includedWeekdaysInCustomerSchedule.includes("Tuesday")) {
          notIncludedDays.push("Wt");
        }
        if (!includedWeekdaysInCustomerSchedule.includes("Wednesday")) {
          notIncludedDays.push("Śr");
        }
        if (!includedWeekdaysInCustomerSchedule.includes("Thursday")) {
          notIncludedDays.push("Czw");
        }
        if (!includedWeekdaysInCustomerSchedule.includes("Friday")) {
          notIncludedDays.push("Pt");
        }
        if (!includedWeekdaysInCustomerSchedule.includes("Saturday")) {
          notIncludedDays.push("Sob");
        }
        if (!includedWeekdaysInCustomerSchedule.includes("Sunday")) {
          notIncludedDays.push("Nd");
        }

        this.employeesAssigned.find(
          (e) => e.employeeId === employeesAssignedToSearchDates.employeeId
        ).notIncludedDays = notIncludedDays;
      }
    },
    combineDatesInRange(startDate, endDate) {
      moment.locale("en");
      const start = moment(startDate);
      const end = moment(endDate);
      const allDates = [];
      let current = start.clone();
      while (current.isSameOrBefore(end)) {
        allDates.push(current);
        current.add(1, "day");
      }
      allDates.sort((a, b) => moment(a).diff(moment(b)));
      return allDates;
    },

    getWeekdayNamesFromGivenDates(dates) {
      moment.locale("en");
      let result = [];
      dates.forEach((date) => {
        const dayOfWeek = moment(date).format("dddd");
        if (!result.includes(dayOfWeek)) {
          result.push(dayOfWeek);
        }
      });
      return result;
    },
    getPlShortDayNameFromFullEn(dayName) {
      const dirEn = {
        MONDAY: "Pon",
        TUESDAY: "Wt",
        WEDNESDAY: "Śr",
        THURSDAY: "Czw",
        FRIDAY: "Pt",
        SATURDAY: "Sob",
        SUNDAY: "Nd",
      };

      return dirEn[dayName];
    },

    formatDate(date) {
      return shared.dateToDayMonthYearFormat(date);
    },
    addAnotherEmployee() {
      const unasignedEmployee = this.employeesOptions.find(
        (employee) =>
          !this.employeesAssigned
            .map((e) => e.employeeId)
            .includes(employee.value)
      );
      this.employeesAssigned.push({
        employeeId: unasignedEmployee.value,
        customerId: this.customerId,
        dateFrom: "",
        dateTo: "",
        days: {
          Pon: { status: false, numberOfHours: null },
          Wt: { status: false, numberOfHours: null },
          Śr: { status: false, numberOfHours: null },
          Czw: { status: false, numberOfHours: null },
          Pt: { status: false, numberOfHours: null },
          Sob: { status: false, numberOfHours: null },
          Nd: { status: false, numberOfHours: null },
        },
        daysBeforeEdit: {
          Pon: { status: false, numberOfHours: 0 },
          Wt: { status: false, numberOfHours: 0 },
          Śr: { status: false, numberOfHours: 0 },
          Czw: { status: false, numberOfHours: 0 },
          Pt: { status: false, numberOfHours: 0 },
          Sob: { status: false, numberOfHours: 0 },
          Nd: { status: false, numberOfHours: 0 },
        },
        holidays: { status: false, numberOfHours: null },
      });
    },
    handlePickEmployee(employeeId, assignedEmployeeIndex) {
      this.employeesAssigned[assignedEmployeeIndex].employeeId = employeeId;
      this.customKey = new Date().getTime();
    },
    handleChangeDate(date, index, key) {
      this.employeesAssigned[index][`${key}`] = date;
      if (!this.checkCustomerAlreadyHasAddedEmployeeInGivenPeriod(index)) {
        this.alreadyAddedEmployeeError = false;
      }
      this.getCustomerScheduleDaysWhenDatesAreFilled(
        this.employeesAssigned[index]
      );
    },
    handleDeleteEmployee(employeeId) {
      this.employeesAssigned = this.employeesAssigned.filter(
        (employee) => employee.employeeId !== employeeId
      );
      this.customKey = new Date().getTime();
    },
    checkCustomerAlreadyHasAddedEmployeeInGivenPeriod(index) {
      let hasAlreadyAddedEmployee = false;
      const givenDates = [];
      const currentDate = moment(
        this.employeesAssigned[index].dateFrom
      ).clone();

      if (
        this.employeesAssigned[index].dateFrom ===
        this.employeesAssigned[index].dateTo
      ) {
        givenDates.push(this.employeesAssigned[index].dateFrom);
      } else {
        while (
          currentDate.isSameOrBefore(
            moment(
              this.employeesAssigned[index].dateTo ||
                this.customerSchedule.dateTo
            )
          )
        ) {
          givenDates.push(currentDate.format("YYYY-MM-DD"));
          currentDate.add(1, "day");
        }
      }

      const orders = this.customerOrders;
      if (orders && orders.length > 0) {
        orders.forEach((order) => {
          const dates = order.days.map((day) =>
            moment(day.date).format("YYYY-MM-DD")
          );
          givenDates.forEach((date) => {
            let employeeHasAddedAbsence = false;
            this.employeesAbsences.forEach((absence) => {
              const absenceEmployeeId = absence.employeeId;
              const absenceDate = moment(absence.date).format("YYYY-MM-DD");
              if (
                absenceDate === date &&
                absenceEmployeeId === order.employee.id
              ) {
                employeeHasAddedAbsence = true;
              }
            });
            if (dates.includes(date) && !employeeHasAddedAbsence) {
              hasAlreadyAddedEmployee = true;
            }
          });
        });
      }

      if (hasAlreadyAddedEmployee) {
        this.alreadyAddedEmployeeError = true;
      } else {
        this.alreadyAddedEmployeeError = false;
      }
      return hasAlreadyAddedEmployee;
    },
    getMinDateForNewSchedule() {
      return moment().add(1, "day").format("YYYY-MM-DD");
    },
    parseDaysToSave(days) {
      let daysToSave = [];
      for (const [key, value] of Object.entries(days)) {
        if (this.customOrder) {
          if (value.numberOfHours && value.numberOfHours > 0) {
            const dayName = this.translateDayPlShortToDayEnName(key);
            const hours = value.numberOfHours;
            daysToSave.push({
              dayName,
              numberOfHours: hours,
            });
          }
        } else {
          if (value.status) {
            const dayName = this.translateDayPlShortToDayEnName(key);
            const hours = value.numberOfHours || null;
            daysToSave.push({
              dayName,
              numberOfHours: hours,
            });
          }
        }
      }
      return daysToSave;
    },
    confirmMaxHoursModal() {
      this.assignEmployeeToCustomer(true);
      this.closeMaxHoursModal();
    },
    async assignEmployeeToCustomer(withoutCheckingHours) {
      try {
        this.loading = true;
        this.employeesAssigned.forEach((e) => (e.mothsWithMaxHours = []));
        const employeesToSend = this.employeesAssigned.map((employee) => ({
          ...employee,
          days: this.parseDaysToSave(employee.days),
        }));
        if (this.customerSchedule && this.customerSchedule.dateTo) {
          for await (const employee of employeesToSend) {
            const orderDateFrom = moment(employee.dateFrom)
              .startOf("day")
              .toDate();
            const orderDateTo = employee.dateTo
              ? moment(employee.dateTo).endOf("day").toDate()
              : moment(this.customerSchedule.dateTo).endOf("day").toDate();

            const orderMonths = [];
            let currentMonth = moment(orderDateFrom);

            while (currentMonth.isSameOrBefore(orderDateTo)) {
              orderMonths.push(currentMonth.format("MM"));
              currentMonth.add(1, "month");
            }

            await this.$store.dispatch("getCustomerSchedulesByMonthAndYear", {
              customerId: this.customerId,
              dates: orderMonths.map((m) => ({
                month: m,
                year: moment(employee.dateFrom).format("YYYY"),
              })),
            });

            if (!withoutCheckingHours) {
              for await (const orderMonth of orderMonths) {
                const employeeScheduledHours = await this.$store.dispatch(
                  "getEmployeeNumberScheduledHoursInMonth",
                  {
                    employeeId: employee.employeeId,
                    month: orderMonth,
                    year: moment(employee.dateFrom).format("YYYY"),
                  }
                );
                const { numberOfScheduledHours, maxNumberOfScheduledHours } =
                  employeeScheduledHours;

                let newScheduledHours = 0;
                let subtractedHours = 0;
                let customerScheduleInMonth = null;
                const customerScheduleByMonthAndYear =
                  this.customerSchedulesByMonthAndYear.find(
                    (schedule) =>
                      schedule.month === orderMonth &&
                      schedule.year === moment(employee.dateFrom).format("YYYY")
                  );
                if (
                  customerScheduleByMonthAndYear &&
                  customerScheduleByMonthAndYear.schedule &&
                  customerScheduleByMonthAndYear.schedule.length > 0
                ) {
                  customerScheduleInMonth =
                    customerScheduleByMonthAndYear.schedule[0];
                }

                customerScheduleInMonth.days.forEach((day) => {
                  const weekDayToAssign = employee.days.find((employeeDay) => {
                    return employeeDay.dayName === day.dayName;
                  });
                  if (weekDayToAssign && weekDayToAssign.status) {
                    weekDayToAssign.numberOfHours = day.numberOfHours;
                  }
                  const isDateInRange = moment(day.date).isBetween(
                    moment(orderDateFrom),
                    moment(orderDateTo),
                    null,
                    "[]"
                  );
                  const isDateInRangeBeforeEdit = !this.selectedOrder
                    ? true
                    : moment(day.date).isBetween(
                        moment(this.selectedOrder.dateFrom),
                        moment(this.selectedOrder.dateTo),
                        null,
                        "[]"
                      );
                  // console.log({
                  //   weekDayToAssign,
                  //   isDateInRange,
                  //   isDateInRangeBeforeEdit,
                  // });
                  if (
                    weekDayToAssign &&
                    isDateInRange &&
                    isDateInRangeBeforeEdit
                  ) {
                    const dayPlShortName = this.getPlShortDayNameFromFullEn(
                      day.dayName
                    );

                    const dayHoursBeforeEdit =
                      employee.daysBeforeEdit[dayPlShortName];
                    if (weekDayToAssign.numberOfHours) {
                      if (
                        dayHoursBeforeEdit.numberOfHours >=
                        weekDayToAssign.numberOfHours
                      ) {
                        subtractedHours =
                          subtractedHours +
                          (dayHoursBeforeEdit.numberOfHours -
                            weekDayToAssign.numberOfHours);
                      } else {
                        newScheduledHours +=
                          weekDayToAssign.numberOfHours -
                          dayHoursBeforeEdit.numberOfHours;
                      }
                    } else {
                      if (
                        dayHoursBeforeEdit.numberOfHours >= day.numberOfHours
                      ) {
                        subtractedHours =
                          subtractedHours +
                          (dayHoursBeforeEdit.numberOfHours -
                            day.numberOfHours);
                      } else {
                        newScheduledHours +=
                          day.numberOfHours - dayHoursBeforeEdit.numberOfHours;
                      }
                    }
                  } else if (!isDateInRangeBeforeEdit) {
                    if (weekDayToAssign && weekDayToAssign.numberOfHours) {
                      newScheduledHours += weekDayToAssign.numberOfHours;
                    } else {
                      newScheduledHours += day.numberOfHours;
                    }
                  } else if (weekDayToAssign && weekDayToAssign.numberOfHours) {
                    newScheduledHours += weekDayToAssign.numberOfHours;
                  }
                });

                // console.log({
                //   numberOfScheduledHours,
                //   newScheduledHours,
                //   subtractedHours,
                //   maxNumberOfScheduledHours,
                // });

                if (
                  numberOfScheduledHours + newScheduledHours >
                  maxNumberOfScheduledHours
                ) {
                  if (!employee.mothsWithMaxHours.includes(orderMonth)) {
                    employee.mothsWithMaxHours.push(orderMonth);
                  }
                  // this.$notify({
                  //   group: "error",
                  //   text: `Opiekun ${employee.employeeId} ma już zaplanowane ${numberOfScheduledHours} godzin w tym miesiącu. Maksymalna liczba godzin to ${maxNumberOfScheduledHours}`,
                  // });
                }
              }
            }
          }
          // console.log({ employeesToSend });
          // if (employeesToSend) {
          //   return;
          // }
          if (employeesToSend.some((e) => e.mothsWithMaxHours.length > 0)) {
            this.loading = false;
            this.modalKey = this.modalKey + 1;
            setTimeout(() => {
              this.openMaxHoursModal();
            }, 300);
            return;
          }

          if (!this.selectedOrder) {
            const response = await Promise.all(
              employeesToSend.map((employee) => {
                const orderDateFrom = moment(employee.dateFrom)
                  .startOf("day")
                  .toDate();
                const orderDateTo = employee.dateTo
                  ? moment(employee.dateTo).endOf("day").toDate()
                  : moment(this.customerSchedule.dateTo).endOf("day").toDate();
                return this.$store.dispatch("addDodOrder", {
                  employeeId: employee.employeeId,
                  customerId: employee.customerId,
                  dateFrom: orderDateFrom,
                  dateTo: orderDateTo,
                  days: employee.days,
                  note: this.orderNote,
                  holidaysStatus: employee.holidays,
                });
              })
            );
            if (response) {
              this.$notify({
                group: "success",
                text: "Opiekun został przypisany pomyślnie",
              });
              if (this.selectedOrder) {
                await this.$store.dispatch("getCustomerOrders", {
                  customerId: this.customerId,
                  ordersYear: this.selectedOrder.ordersYear,
                  ordersMonth: this.selectedOrder.ordersMonth,
                });
              } else {
                await this.$store.dispatch("getCustomerOrders", {
                  customerId: this.customerId,
                });
              }
              await this.$store.dispatch("getCustomerMessages", {
                customerId: this.customerId,
              });
              this.selectedOrder = null;
              this.isAssigningVisible = false;
            }
            this.$emit("updated");
          } else {
            const response = await Promise.all(
              // return - inaczej Promise.all nie czeka na dispatch, a odrzucenie (np. blokada
              // rozliczonego miesiąca) nie trafia do catch i panel pokazuje fałszywy sukces.
              employeesToSend.map((employee) => {
                return this.$store.dispatch("editDodOrder", {
                  data: {
                    employeeId: employee.employeeId,
                    customerId: employee.customerId,
                    dateFrom: moment(employee.dateFrom).startOf("day").toDate(),
                    dateTo: employee.dateTo
                      ? moment(employee.dateTo).endOf("day").toDate()
                      : moment(this.customerSchedule.dateTo)
                          .endOf("day")
                          .toDate(),
                    days: employee.days,
                    holidaysStatus: employee.holidays,
                  },
                  orderId: this.selectedOrder.id,
                });
              })
            );
            if (response) {
              // Edycja bez ani jednego zaznaczonego dnia czyści okres zamiast przypisywać opiekuna,
              // więc komunikat o "przypisaniu" byłby mylący.
              const isClearingPeriod = employeesToSend.every(
                (employee) => employee.days.length === 0
              );
              this.$notify({
                group: "success",
                text: isClearingPeriod
                  ? "Dni opiekuna w wybranym okresie zostały wyczyszczone"
                  : "Opiekun został przypisany pomyślnie",
              });

              if (this.selectedOrder) {
                await this.$store.dispatch("getCustomerOrders", {
                  customerId: this.customerId,
                  ordersYear: this.selectedOrder.ordersYear,
                  ordersMonth: this.selectedOrder.ordersMonth,
                });
              } else {
                await this.$store.dispatch("getCustomerOrders", {
                  customerId: this.customerId,
                });
              }
              this.selectedOrder = null;
              this.isAssigningVisible = false;
              this.$emit("updated");
            }
          }
        } else {
          this.$notify({
            group: "error",
            text: "Należy wybrać zapotrzebowanie dla podopiecznego",
          });
        }
      } catch (error) {
        console.log(error);
        // Backend DOD zwraca `message` jako jeden polski string - także dla błędów walidacji
        // pól (exceptionFactory w main.ts) - więc pokazujemy go wprost. Generyk zostaje na
        // wypadek błędu bez treści (sieć, 5xx).
        const backendMsg =
          error && error.response && error.response.data && error.response.data.message;
        this.$notify({
          group: "error",
          text:
            typeof backendMsg === "string" && backendMsg
              ? backendMsg
              : "Nie udało się przypisać opiekuna",
        });
      } finally {
        this.loading = false;
      }
    },
    translateDayPlShortToDayEnName(dayPlShort) {
      const translations = {
        Pon: "MONDAY",
        Wt: "TUESDAY",
        Śr: "WEDNESDAY",
        Czw: "THURSDAY",
        Pt: "FRIDAY",
        Sob: "SATURDAY",
        Nd: "SUNDAY",
      };
      return translations[dayPlShort];
    },
  },
  computed: {
    customerSchedulesByMonthAndYear() {
      return this.$store.getters.getDodCustomerSchedulesByMonthAndYear;
    },
    employeesAbsences() {
      let allAbsences = [];
      if (this.customerOrders && this.customerOrders.length > 0) {
        this.customerOrders.forEach((order) => {
          const employee = order.employee;
          const absences = employee.absences;
          absences.forEach((absence) => {
            absence.firstName = employee.firstName;
            absence.lastName = employee.lastName;
            absence.employeeId = employee.id;
            allAbsences.push(absence);
          });
        });
      }
      return allAbsences;
    },

    employees() {
      return this.$store.getters.getDodEmployeesPrimaryInfo;
    },
    employeesOptions() {
      if (this.employees && this.employees.data) {
        return this.employees.data.map((e) => {
          return {
            name: `${e.firstName} ${e.lastName}`,
            value: e.id,
            shortName: `${e.firstName} ${e.lastName}`,
            mainAppUserId: e.mainAppUserId,
          };
        });
      } else {
        return [];
      }
    },
    customerSchedule() {
      return this.$store.getters.getDodSelectedCustomerSchedule?.data?.[0];
    },

    scheduledDaysCounter() {
      let dayHoursCounter = {
        MONDAY: 0,
        TUESDAY: 0,
        WEDNESDAY: 0,
        THURSDAY: 0,
        FRIDAY: 0,
        SATURDAY: 0,
        SUNDAY: 0,
      };
      if (this.customerSchedule) {
        const days = this.customerSchedule.days;
        days.forEach((day) => {
          const dayName = day.dayName;
          if (!dayHoursCounter[dayName]) {
            dayHoursCounter[dayName] = day.numberOfHours;
          } else if (dayHoursCounter[dayName] < day.numberOfHours) {
            dayHoursCounter[dayName] = day.numberOfHours;
          }
        });
      }
      return dayHoursCounter;
    },
    customerOrders() {
      return this.$store.getters.getDodSelectedCustomerOrders?.data;
    },
    notIncludedDays() {
      if (this.customerSchedule) {
        const customerScheduleDaysInMonth = this.customerSchedule.days;
        const includedWeekdaysInCustomerSchedule =
          this.getWeekdayNamesFromGivenDates(
            customerScheduleDaysInMonth.map((d) => d.date)
          );
        let days = [];
        if (!includedWeekdaysInCustomerSchedule.includes("Monday")) {
          days.push("Pon");
        }
        if (!includedWeekdaysInCustomerSchedule.includes("Tuesday")) {
          days.push("Wt");
        }
        if (!includedWeekdaysInCustomerSchedule.includes("Wednesday")) {
          days.push("Śr");
        }
        if (!includedWeekdaysInCustomerSchedule.includes("Thursday")) {
          days.push("Czw");
        }
        if (!includedWeekdaysInCustomerSchedule.includes("Friday")) {
          days.push("Pt");
        }
        if (!includedWeekdaysInCustomerSchedule.includes("Saturday")) {
          days.push("Sob");
        }
        if (!includedWeekdaysInCustomerSchedule.includes("Sunday")) {
          days.push("Nd");
        }
        return days;
      } else {
        return [];
      }
    },
  },
};
</script>

<style scoped>
.assigning-box {
  border-radius: 5px;
  border: 1px solid rgba(9, 7, 65, 0.25);
  margin-top: 2rem;
  padding-bottom: 5rem;
}
.select-employee {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
}
.select-employee div:first-child {
  width: 570px;
}
.days-label {
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-transform: uppercase;
}
.days {
  border-radius: 5px;
  border: 1px solid rgba(9, 7, 65, 0.25);
  display: flex;
  width: 100%;
  margin: 2rem 0;
}
.day {
  border-right: 1px solid rgba(9, 7, 65, 0.25);
  flex: 1 1 0px;
  height: 54px;
  text-align: center;
}
.day:last-child {
  border-right: none;
}
.day input {
  border: none;
  text-align: center;
  border-bottom: 1px solid black;
  width: 100%;

  background: none;
}
.day input:focus {
  outline: none;
}
.day-color {
  background: rgba(226, 3, 126, 0.07);
}
.custom-order-input {
  display: flex;
  align-items: center;
  font-size: 14px;
  margin-left: 0.75rem;
  padding-bottom: 1rem;
}
.custom-order-input label {
  margin: 0;
  margin-left: 1rem;
}
.assign-button {
  display: flex;
  justify-content: flex-end;
}
.already-added-employee-error {
  display: flex;
  padding: 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
  align-self: stretch;
  border-radius: 5px;
  color: #fff;
  background: #ec0909;
  margin: 0 0.5rem 0 1rem;
}
.add-employee {
  text-decoration: underline;
  cursor: pointer;
}
.delete-char {
  font-size: 14px;
  font-weight: 600;
  margin-left: auto;
  color: #ec0909;
  cursor: pointer;
}
.modal-buttons {
  display: flex;
  gap: 10px;
  justify-content: center;
}
.order-note {
  margin-left: 1rem;
  width: 99%;
  min-height: 100px;
  padding: 5px;
}
</style>
